<template>
	<div @mouseover="ResetTimeOutTimer">
		<div v-if="test">
			<b-modal id="addModel" v-model="showModal" title="Session Timeout" size="sm" centered>
				<div class="dropdown-divider bg-dark"></div>
				<p class="font-weight-normal">
					You're being logged out due to inactivity. <br />
					Please choose to stay signed in or to logoff. <br />
					Otherwise you will loqout automatically.
				</p>
				<div class="dropdown-divider bg-dark"></div>
				<template #modal-footer>
					<div>
						<base-button type="button" class="btn btn-light" @click="IdleTimeout"> Log out</base-button>
						<base-button type="button" class="btn btn-primary" @click="ResetTimeOutTimer">
							Stay Logged In {{ timoutWarning / 1000 }}
						</base-button>
					</div>
				</template>
			</b-modal>
		</div>
		<!--no-close-on-backdrop-->
		<b-modal
			centered
			size="sm"
			id="modal_activity_progress_bar"
			hide-footer
			hide-header
			class="modal_activity_progress_bar"
		>
			<p class="h1 text-center mb-4">Activity</p>
			<b-progress
				:value="progressStartValue"
				height="16px"
				variant="primary"
				:striped="true"
				v-if="showProgressMeter"
				class="mt-2"
				:animated="true"
				show-progress
			></b-progress>
			<div align="center" class="text-center justify-content-center">
				<b-icon
					icon="three-dots"
					class="text-center"
					animation="cylon"
					font-scale="4"
					v-if="!showProgressMeter"
				></b-icon>
				<br />
				<small class="text-center" v-if="progressTitle">{{ progressTitle }}</small>
				<br />
				<small class="text-center" v-if="progressMessage">{{ progressMessage }}</small>
			</div>
		</b-modal>
		<div
			class="wrapper"
			:style="logoutStatus ? '-webkit-filter: blur(5px) grayscale(60%);background: rgba(0, 0, 0, 0.3);' : ''"
		>
			<notifications position="bottom center" />
			<div
				class="sidenav navbar navbar-vertical fixed-left navbar-expand-xs navbar-light bg-white sidenav-custom"
				@mouseenter="$sidebar.onMouseEnter()"
				@mouseleave="$sidebar.onMouseLeave()"
				:data="backgroundColor"
			>
				<div class="scrollbar-inner" ref="sidebarScrollArea">
					<div class="sidenav-header sidenav-logo d-flex align-items-center">
						<b-navbar-brand href="#">
							<img
								v-bind:src="pageLogo"
								:style="logoStyle"
								class="navbar-brand-img"
								alt="Sidebar logo"
							/><br />
						</b-navbar-brand>
						<div class="ml-auto">
							<!-- :class="{active: !$sidebar.isMinimized}" -->
							<div class="sidenav-toggler d-none d-xl-block" @click="minimizeSidebar">
								<div class="sidenav-toggler-inner">
									<i class="sidenav-toggler-line"></i>
									<i class="sidenav-toggler-line"></i>
									<i class="sidenav-toggler-line"></i>
								</div>
							</div>
						</div>
					</div>
					<slot></slot>
					<div class="navbar-inner">
						<b-navbar-nav>
							<div>
								<slot name="links">
									<!-- Home -->
									<side-home-default-group
										v-if="navigate.includes('HOME_DEFAULT')"
									></side-home-default-group>
									<side-home-mobility-group
										v-if="navigate.includes('HOME_MOBILITY')"
									></side-home-mobility-group>
									<side-home-dynamic-group
										v-if="navigate.includes('DYNAMIC')"
									></side-home-dynamic-group>
									<!-- eSim -->
									<side-e-sim-group
										v-if="navigate.includes('ESIM') && !navigate.includes('DYNAMIC')"
									></side-e-sim-group>
									<side-e-sim-dynamic-group
										v-if="navigate.includes('DYNAMIC')"
									></side-e-sim-dynamic-group>
									<!-- OTA -->
									<side-ota-group
										v-if="navigate.includes('OTA') && !navigate.includes('DYNAMIC')"
									></side-ota-group>
									<side-ota-dynamic-group
										v-if="navigate.includes('DYNAMIC')"
									></side-ota-dynamic-group>
									<!-- Entitlements -->
									<side-entitlements-group
										v-if="navigate.includes('ENTITLEMENTS') && !navigate.includes('DYNAMIC')"
									></side-entitlements-group>
									<side-entitlements-dynamic-group
										v-if="navigate.includes('DYNAMIC')"
									></side-entitlements-dynamic-group>
									<!-- CDMA -->
									<side-cdma-group
										v-if="navigate.includes('CDMA') && !navigate.includes('DYNAMIC')"
									></side-cdma-group>
									<side-cmda-dynamic-group
										v-if="navigate.includes('DYNAMIC')"
									></side-cmda-dynamic-group>
									<!-- ENUM -->
									<side-enum-group
										v-if="navigate.includes('ENUM') && !navigate.includes('DYNAMIC')"
									></side-enum-group>
									<side-enum-dynamic-group
										v-if="navigate.includes('DYNAMIC')"
									></side-enum-dynamic-group>
									<!-- Reports -->
									<side-reports-basic-group
										v-if="navigate.includes('REPORTS_BASIC') && !navigate.includes('DYNAMIC')"
									></side-reports-basic-group>
									<side-reports-group
										v-if="navigate.includes('REPORTS') && !navigate.includes('DYNAMIC')"
									></side-reports-group>
									<side-reports-group
										v-if="navigate.includes('REPORTS_CUSTOM') && !navigate.includes('DYNAMIC')"
									></side-reports-group>
									<side-reports-dynamic-group
										v-if="navigate.includes('DYNAMIC')"
									></side-reports-dynamic-group>
									<!-- Troubleshooting -->
									<side-trouble-basic-group
										v-if="navigate.includes('TROUBLE_BASIC') && !navigate.includes('DYNAMIC')"
									></side-trouble-basic-group>
									<side-trouble-custom-group
										v-if="navigate.includes('TROUBLE_CUSTOM') && !navigate.includes('DYNAMIC')"
									></side-trouble-custom-group>
									<side-trouble-dynamic-group
										v-if="navigate.includes('DYNAMIC')"
									></side-trouble-dynamic-group>
									<!-- Administration -->
									<side-admin-basic-group
										v-if="navigate.includes('ADMIN_DEFAULT')"
									></side-admin-basic-group>
									<side-admin-custom-group
										v-if="navigate.includes('ADMIN_CUSTOM')"
									></side-admin-custom-group>
									<side-admin-mobility-group
										v-if="navigate.includes('ADMIN_MOBILITY')"
									></side-admin-mobility-group>
									<side-admin-dynamic-group
										v-if="navigate.includes('DYNAMIC')"
									></side-admin-dynamic-group>
								</slot>
							</div>
							<div>
								<nav>
									<a href="#" class="nav-link" :class="{'disable-logout': isLogoutClicked }" v-on:click="onLogOut()">
										<i class="fa fa-sign-out-alt"></i>
										<span class="nav-link-text">Logout</span>
									</a>
								</nav>
							</div>
						</b-navbar-nav>
						<slot name="links-after"></slot>
					</div>
				</div>
			</div>

			<div class="main-content">
				<div
					align="center"
					id="routerAlerts"
					style="position: fixed; top: 2%; right: 0%; z-index: 100; width: 100%"
				></div>
				<top-navigator :type="$route.meta.navbarType"></top-navigator>

				<div @click="$sidebar.displaySidebar(false)" style="margin-top: 4.9rem">
					<fade-transition :duration="200" origin="center top" mode="out-in">
						<!-- your content here -->
						<router-view></router-view>
					</fade-transition>
				</div>
				<content-footer v-if="!$route.meta.hideFooter"></content-footer>
			</div>
		</div>
	</div>
</template>
<script>
/* eslint-disable no-new */
import {mapGetters} from "vuex";
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import TopNavigator from "./TopNavigator.vue";
import ContentFooter from "../Layout/ContentFooter.vue";
import configDirective from "../../common/directive/config-directive";
import {CollapseTransition} from "vue2-transitions";
import AuthService from "@/common/api-services/auth-service";
import {LOGOUT} from "@/store/auth.module";
import initService from "../../common/api-services/init-service";
import SideHomeMobilityGroup from "./SideGroup/Side-Home-Mobility-Group.vue";
import SideHomeDefaultGroup from "./SideGroup/Side-Home-Default-Group.vue";
import SideHomeDynamicGroup from "./SideGroup/Side-Home-Dynamic-Group.vue";
import SideESimGroup from "./SideGroup/Side-E-Sim-Group.vue";
import SideESimDynamicGroup from "./SideGroup/Side-E-Sim-Dynamic-Group.vue";
import SideOtaGroup from "./SideGroup/Side-Ota-Group.vue";
import SideOtaDynamicGroup from "./SideGroup/Side-Ota-Dynamic-Group.vue";
import SideCdmaGroup from "./SideGroup/Side-Cdma-Group.vue";
import SideCmdaDynamicGroup from "./SideGroup/Side-Cmda-Dynamic-Group.vue";
import SideReportsGroup from "./SideGroup/Side-Reports-Group.vue";
import SideReportsBasicGroup from "./SideGroup/Side-Reports-Basic-Group.vue";
import SideReportsDynamicGroup from "./SideGroup/Side-Reports-Dynamic-Group.vue";
import SideAdminBasicGroup from "./SideGroup/Side-Admin-Basic-Group.vue";
import SideAdminCustomGroup from "./SideGroup/Side-Admin-Custom-Group.vue";
import SideAdminMobilityGroup from "./SideGroup/Side-Admin-Mobility-Group.vue";
import SideAdminDynamicGroup from "./SideGroup/Side-Admin-Dynamic-Group.vue";
import SideTroubleBasicGroup from "./SideGroup/Side-Trouble-Basic-Group.vue";
import SideTroubleCustomGroup from "./SideGroup/Side-Trouble-Custom-Group.vue";
import SideTroubleDynamicGroup from "./SideGroup/Side-Trouble-Dynamic-Group.vue";
import SideEnumGroup from "./SideGroup/Side-Enum-Group.vue";
import SideEnumDynamicGroup from "./SideGroup/Side-Enum-Dynamic-Group.vue";
import SideEntitlementsGroup from "@/views/Navigator/SideGroup/Side-Entitlements-Group";
import SideEntitlementsDynamicGroup from "@/views/Navigator/SideGroup/Side-Entitlements-Dynamic-Group";

function hasElement(className) {
	return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
	if (hasElement(className)) {
		new PerfectScrollbar(`.${className}`);
	} else {
		setTimeout(() => {
			initScrollbar(className);
		}, 100);
	}
}

let VUE_APP_SESSION_TIMEOUT_MINUTES = `${process.env.VUE_APP_SESSION_TIMEOUT_MINUTES}`;
export default {
	name: "side-navigator",
	components: {
		SideEntitlementsGroup,
		SideEntitlementsDynamicGroup,
		TopNavigator,
		ContentFooter,
		CollapseTransition,
		SideTroubleDynamicGroup,
		SideTroubleCustomGroup,
		SideTroubleBasicGroup,
		SideHomeMobilityGroup,
		SideHomeDefaultGroup,
		SideHomeDynamicGroup,
		SideReportsBasicGroup,
		SideReportsDynamicGroup,
		SideAdminDynamicGroup,
		SideAdminMobilityGroup,
		SideAdminCustomGroup,
		SideAdminBasicGroup,
		SideCdmaGroup,
		SideCmdaDynamicGroup,
		SideESimGroup,
		SideESimDynamicGroup,
		SideOtaGroup,
		SideOtaDynamicGroup,
		SideReportsGroup,
		SideEnumGroup,
		SideEnumDynamicGroup,
	},
	data() {
		return {
			backgroundColor: "green",
			logoutStatus: false,
			timer: null,
			progressStartValue: 0,
			progressTitle: "",
			progressMessage: "",
			showProgressMeter: true,
			test: false,
			showModal: false,
			timoutWarning: 0,
			warningTimer: "",
			timeoutTimer: "",
			isMounted: false,
			pageTitle: "DCC Provisioning Portal",
			pageLogo: process.env.VUE_APP_PORTAL_LOGO,
			logoStyle: "",
			isPortalAdminStatus: false,
			isAdminStatus: false,
			groups: [],
			navigate: [],
			isLogoutClicked: false,
		};
	},

	methods: {
		initScrollbar() {
			let isWindows = navigator.platform.startsWith("Win");
			if (isWindows) {
				initScrollbar("sidenav");
			}
		},

		async onLogOut() {
			if(!this.isLogoutClicked) {
				this.isLogoutClicked = true;
			} else {
				// prevent excessive logout clicks
				return;
			}
			try {
				initService.clearCache();
				await AuthService.logoutService();
				await this.$store.dispatch(LOGOUT);
			} catch (error) {
				console.error(error);
			} finally {
				this.$router.push({name: "login"});
			}
		},

		setProgressTimer() {
			this.timer = setInterval(() => {
				this.progressStartValue = this.progressStartValue + (Math.random() * 300) / this.progressStartValue;
				if (this.progressStartValue > 100) {
					this.progressStartValue = 10;
				}
			}, 1000);
		},
		startWarningTimer() {
			this.timoutWarning = 10000;
			let timerId = null;
			if (this.isAuthenticated || this.timoutWarning !== 0) {
				if (this.isIdle) {
					timerId = setInterval(() => {
						this.timoutWarning -= 1000;
						if (this.timoutWarning < 11000) {
							this.showModal = true;
							this.$bvModal.show("addModel");
						}
						if (this.timoutWarning < 1) {
							clearInterval(timerId);
							this.showModal = false;
							this.IdleTimeout();
						}
					}, 1000);
				} else {
					clearInterval(this.timoutWarning);
				}
			}
		},
		ResetTimeOutTimer() {
			this.showModal = false;
			this.timoutWarning = VUE_APP_SESSION_TIMEOUT_MINUTES * 60000;
		},
		IdleTimeout() {
			this.$root.$emit("logoutEvent", true);
		},
		callTimerStart() {
			if (this.isIdle == true) {
				this.startWarningTimer();
			} else {
				this.ResetTimeOutTimer();
			}
		},
		minimizeSidebar() {
			if (this.$sidebar) {
				this.$sidebar.toggleMinimize();
			}
		},
	},

	mounted() {
		this.$sidebar.isMinimized = this.$sidebar.breakpoint < window.innerWidth;
		this.pageTitle = process.env.VUE_APP_CLIENT.toString().toUpperCase() + " Portal";
		this.pageLogo = "/img/brand/" + process.env.VUE_APP_CLIENT.toString() + ".png";
		let width = `137px`;
		let height = `96px`;
		this.logoStyle = `width: ${width}; height: ${height}`;
		this.minimizeSidebar();

		if (!this.isAuthenticated) {
			this.$router.push({name: "login"});
			sessionStorage.clear();
		}
		this.initScrollbar();

		//this will always send to login if we don't have config data.
		let config = configDirective.getConfigData();
		if (!config || config.length < 25) {
			this.$router.push({name: "login"});
			sessionStorage.clear();
		}

		this.$root.$on("logoutEvent", res => {
			if (res) {
				this.logoutStatus = true;
				//modal_activity_progress_bar
				this.progressTitle = "Please wait while we process your action.";
				this.progressMessage = "";
				this.showProgressMeter = false;
				this.$bvModal.show("modal_activity_progress_bar");

				//force clear.
				sessionStorage.clear();
				// this.$router.push("/login");
				// window.location.href = "/login";
				this.$router.replace("/login");
			}
		});

		this.$root.$on("loadingPanelShow", res => {
			// console.log('loading panel show:', res);
			if (res) {
				this.logoutStatus = true;
				//modal_activity_progress_bar
				this.progressTitle = "Please wait while we process your action.";
				this.progressMessage = "";
				this.showProgressMeter = false;
				this.$bvModal.show("modal_activity_progress_bar");
			}
		});

		this.$root.$on("loadingPanelHide", res => {
			//console.log('loading panel hide:', res);
			if (res) {
				this.logoutStatus = false;
				//modal_activity_progress_bar
				this.$bvModal.hide("modal_activity_progress_bar");
			}
		});

		this.$root.$on("loadingPanelUpdate", res => {
			//console.log('loading panel update:', res);
			if (res) {
				this.logoutStatus = true;
				//modal_activity_progress_bar
				if (res.title) this.progressTitle = res.title;
				if (res.message) this.progressMessage = res.message;
				if (res.progress) this.showProgressMeter = res.progress;
				this.$bvModal.show("modal_activity_progress_bar");
			}
		});
		this.isPortalAdminStatus = initService.getPortalAdminRole();
		this.isAdminStatus = initService.getAdministratorRole() || initService.getPortalAdminRole();
		this.groups = initService.getGroups();
		this.navigate = configDirective.getNavigation();
	},
	created() {
		this.isMounted = this.isAuthenticated;
		this.test = this.isAuthenticated;
		this.callTimerStart(); // We have to call it due to any activity
	},
	computed: {
		...mapGetters(["isAuthenticated"]),
		currentRouteName() {
			return this.$route.name;
		},
		isIdle() {
			return this.$store.state.idleVue.isIdle;
		},
	},
	watch: {
		isIdle(c) {
			if (c) {
				this.callTimerStart();
			}
		},
	},
	beforeDestroy() {
		if (this.$sidebar.showSidebar) {
			this.$sidebar.showSidebar = false;
		}
	},
};
</script>
<style lang="postcss">
.overlay {
	position: fixed;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	background-color: rgba(0, 0, 0, 0.3);
	z-index: 100;
	display: flex;
	align-items: center;
	justify-content: center;
}

.modal {
	box-shadow: 1px 2px 4px rgba(153, 155, 168, 0.12);
	border-radius: 4px;
	@apply bg-white p-2;
}

.modal__title {
	color: #38404f;
	@apply flex items-center justify-between p-3 font-bold;
}

.fixed-bottom-sidenav {
	position: fixed;
	bottom: 0px;
}

.sidenav-logo {
	z-index: 10;
	position: sticky;
	top: 0;
	background-color: rgba(255, 254, 254, 0.9);
}
.disable-logout {
	cursor: progress;
}
</style>
